import { useEffect, useState } from 'react';

/**
 * Follow a value, but only after it has stopped changing for a moment.
 *
 * Used wherever a keystroke would otherwise become a request.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
